import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;
declare var globalConstants;
declare var getGlobalConstantDisplay;
declare var defaultSettingsGrid;

@Component({
  selector: 'netting-h',
  templateUrl: './netting-h.component.html',
  styleUrls: ['./netting-h.component.css'],
})

export class NettingHistory implements OnInit {

  constructor (private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Targets and Netting Rule Event Log");

    $(document).ready(function() {
  			// prepare the data
  			var data = [ {
  				"timestamp" : "5/5/2015 06:08:46.689",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Default",
  				"ccyPair" : "USD/JPY",
  				"exposureLimit" : "500M",
  				"volatilityLimit" : "1.25"
  			}, {
  				"timestamp" : "5/5/2015 06:08:47.577",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account D",
  				"ccyPair" : "EUR/USD",
  				"exposureLimit" : "500M",
  				"volatilityLimit" : "1.1"
  			}, {
  				"timestamp" : "5/5/2015 06:08:47.989",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountCode" : "Account E",
  				"ccyPair" : "USD/CHF",
  				"exposureLimit" : "150M",
  				"volatilityLimit" : "1.3"
  			} ];

  			// initialize jqxGrid
  			var source = {
  				localdata : data,
  				datafields : [ {
  					name : 'timestamp',
  					type : 'string'
  				}, {
  					name : 'user',
  					type : 'string'
  				}, {
  					name : 'ipAddress',
  					type : 'string'
  				}, {
  					name : 'accountCode',
  					type : 'string'
  				}, {
  					name : 'ccyPair',
  					type : 'string'
  				}, {
  					name : 'exposureLimit',
  					type : 'string'
  				}, {
  					name : 'volatilityLimit',
  					type : 'string'
  				} ]
  			};
  			var settings = defaultGridViewSettings("#jqxgrid", source);
  			settings.columns = [ {
  				text : 'Timestamp',
  				columntype : 'textbox',
  				datafield : 'timestamp',
  				width : '160'
  			}, {
  				text : 'User',
  				columntype : 'textbox',
  				datafield : 'user',
  				width : '100'
  			}, {
  				text : 'IP Address',
  				columntype : 'textbox',
  				datafield : 'ipAddress',
  				width : '80'
  			}, {
  				text : 'Account',
  				columntype : 'textbox',
  				datafield : 'accountCode',
  				width : '120'
  			}, {
  				text : 'Ccy Pair',
  				columntype : 'textbox',
  				datafield : 'ccyPair',
  				width : '100'
  			}, {
  				text : 'Portfolio Exposure Limit',
  				columntype : 'textbox',
  				datafield : 'exposureLimit',
  				width : '150'
  			}, {
  				text : 'Volatility Upper Limit',
  				columntype : 'textbox',
  				datafield : 'volatilityLimit',
  				width : '150'
  			} ];
  			$("#jqxgrid").jqxGrid(settings);
  		});

  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/netting-h/netting-h.component.ts